import { Bedarf, BedarfPrioritaet, BedarfStatus, CreateBedarfDto } from '../../types/bedarf';

/**
 * The starting values of `BedarfeForm` — empty for a new Bedarf. Its own file so
 * the create page can tell an untouched form from one somebody has started on.
 */
export function buildBedarfFormValues(initialData?: Bedarf): CreateBedarfDto {
  return {
    // Stammdaten
    childFirstName: initialData?.childFirstName || '',
    childLastName: initialData?.childLastName || '',
    childDateOfBirth: initialData?.childDateOfBirth ? initialData.childDateOfBirth.split('T')[0] : '',
    childGender: initialData?.childGender || undefined,
    childStreet: initialData?.childStreet || '',
    childCityId: initialData?.childCityId || '',
    childPostalCode: initialData?.childPostalCode || '',

    // Schulische Angaben
    schoolName: initialData?.schoolName || '',
    schoolStreet: initialData?.schoolStreet || '',
    schoolCityId: initialData?.schoolCityId || '',
    schoolPostalCode: initialData?.schoolPostalCode || '',
    schoolClass: initialData?.schoolClass || '',

    // Bedarf & Diagnose
    diagnosis: initialData?.diagnosis || '',
    supportDescription: initialData?.supportDescription || '',
    specialNeeds: initialData?.specialNeeds || '',

    // Stundenplan - Start/End times per day
    startTimeMonday: initialData?.startTimeMonday || '',
    endTimeMonday: initialData?.endTimeMonday || '',
    startTimeTuesday: initialData?.startTimeTuesday || '',
    endTimeTuesday: initialData?.endTimeTuesday || '',
    startTimeWednesday: initialData?.startTimeWednesday || '',
    endTimeWednesday: initialData?.endTimeWednesday || '',
    startTimeThursday: initialData?.startTimeThursday || '',
    endTimeThursday: initialData?.endTimeThursday || '',
    startTimeFriday: initialData?.startTimeFriday || '',
    endTimeFriday: initialData?.endTimeFriday || '',
    includesBreaksOgs: initialData?.includesBreaksOgs || false,

    // Rahmenbedingungen
    startDateRequested: initialData?.startDateRequested ? initialData.startDateRequested.split('T')[0] : '',
    endDateRequested: initialData?.endDateRequested ? initialData.endDateRequested.split('T')[0] : '',
    currentSituation: initialData?.currentSituation || '',

    // Kostenträger / Formalien
    kostentraegerName: initialData?.kostentraegerName || '',
    kostentraegerAnsprechpartner: initialData?.kostentraegerAnsprechpartner || '',
    kostentraegerEmail: initialData?.kostentraegerEmail || '',
    kostentraegerPhone: initialData?.kostentraegerPhone || '',
    hasApproval: initialData?.hasApproval || false,
    hasCarePlan: initialData?.hasCarePlan || false,
    legalBasis: initialData?.legalBasis || '',

    // Elternkontakt
    parentName: initialData?.parentName || '',
    parentPhone: initialData?.parentPhone || '',
    parentEmail: initialData?.parentEmail || '',

    // Meta
    status: initialData?.status || BedarfStatus.OFFEN,
    priority: initialData?.priority || BedarfPrioritaet.MITTEL,
    notes: initialData?.notes || '',
  };
}
